/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: c3d9d0a0 (Wed Sep 23 18:58:40 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import {
  EnrollmentInviteProgram,
  EnrollmentInviteProgramFromJSON,
  EnrollmentInviteProgramToJSON,
  InvitationSource,
} from './'

/**
 *
 * @export
 * @interface CommunityInviteItem
 */
export interface CommunityInviteItem {
  /**
   * The unique identifier of the invitation.
   * @type string
   * @memberof CommunityInviteItem
   */
  uuid: string
  /**
   * The status of the invitation. Can be `InProgress`, `Complete`, `Declined` or `Cancelled`
   * @type string
   * @memberof CommunityInviteItem
   */
  status: CommunityInviteItemStatusEnum
  /**
   * Email that the invite was sent to.
   * @type string
   * @memberof CommunityInviteItem
   */
  sentToEmail: string
  /**
   * First name of the parent the invitation is being sent to.
   * @type string
   * @memberof CommunityInviteItem
   */
  parentFirstName: string
  /**
   * The last name provided by the user.
   * @type string
   * @memberof CommunityInviteItem
   */
  parentLastName: string
  /**
   * Unique identifier of the community the enrollment invitation is for.
   * @type number
   * @memberof CommunityInviteItem
   */
  communityKey: number
  /**
   * Name of the community the enrollment invitation is for.
   * @type string
   * @memberof CommunityInviteItem
   */
  communityName: string
  /**
   * The programs this enrollment invitation pertains to, as well as the number of student spots per program.
   * @type {Array<EnrollmentInviteProgram>}
   * @memberof CommunityInviteItem
   */
  programs: Array<EnrollmentInviteProgram>
  /**
   * The date the invitation was sent.
   * @type Date
   * @memberof CommunityInviteItem
   */
  invitationDate: Date
  /**
   * The unique identifier of the parent user.
   * @type number
   * @memberof CommunityInviteItem
   */
  parentUserKey?: number
  /**
   *
   * @type InvitationSource
   * @memberof CommunityInviteItem
   */
  source?: InvitationSource
  /**
   * The date when the invitation was resent. This corresponds to the Modified date field in the database.
   * @type Date
   * @memberof CommunityInviteItem
   */
  resentDate?: Date
}

/**
 * @export
 * @enum {string}
 */
export enum CommunityInviteItemStatusEnum {
  InProgress = 'InProgress',
  Complete = 'Complete',
  Cancelled = 'Cancelled',
  Declined = 'Declined',
}

export function CommunityInviteItemFromJSON(json: any): CommunityInviteItem {
  return CommunityInviteItemFromJSONTyped(json, false)
}

export function CommunityInviteItemFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CommunityInviteItem {
  if (json === undefined || json === null) {
    return json
  }
  return {
    uuid: json['uuid'],
    status: json['status'],
    sentToEmail: json['sentToEmail'],
    parentFirstName: json['parentFirstName'],
    parentLastName: json['parentLastName'],
    communityKey: json['communityKey'],
    communityName: json['communityName'],
    programs: (json['programs'] as Array<any>).map(
      EnrollmentInviteProgramFromJSON
    ),
    invitationDate: new Date(json['invitationDate']),
    parentUserKey: !exists(json, 'parentUserKey')
      ? undefined
      : json['parentUserKey'],
    source: !exists(json, 'source') ? undefined : json['source'],
    resentDate: !exists(json, 'resentDate')
      ? undefined
      : new Date(json['resentDate']),
  }
}

export function CommunityInviteItemToJSON(
  value?: CommunityInviteItem | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    uuid: value.uuid,
    status: value.status,
    sentToEmail: value.sentToEmail,
    parentFirstName: value.parentFirstName,
    parentLastName: value.parentLastName,
    communityKey: value.communityKey,
    communityName: value.communityName,
    programs: (value.programs as Array<any>).map(EnrollmentInviteProgramToJSON),
    invitationDate: value.invitationDate.toISOString().substr(0, 10),
    parentUserKey: value.parentUserKey,
    source: value.source,
    resentDate:
      value.resentDate === undefined
        ? undefined
        : value.resentDate.toISOString().substr(0, 10),
  }
}
